// ets_tracing: off
export class Stack {
  constructor(value, previous) {
    this.value = value;
    this.previous = previous;
  }

}
//# sourceMappingURL=index.mjs.map